
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/pengelolaan-kinerja-dinas/pemberi-predikat-kinerja-organisasi",
      function () {
        return require("private-next-pages/pengelolaan-kinerja-dinas/pemberi-predikat-kinerja-organisasi/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/pengelolaan-kinerja-dinas/pemberi-predikat-kinerja-organisasi"])
      });
    }
  